import { createFileRoute } from "@tanstack/react-router";
import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Search as SearchIcon } from "lucide-react";
import { TrackRow } from "@/components/TrackRow";
import type { Track } from "@/stores/player";

export const Route = createFileRoute("/_authed/search")({
  head: () => ({ meta: [{ title: "Search — Sura" }] }),
  component: SearchPage,
});

function SearchPage() {
  const [q, setQ] = useState("");
  const [results, setResults] = useState<Track[]>([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!q.trim()) { setResults([]); return; }
    const t = setTimeout(async () => {
      setLoading(true);
      try {
        const { data } = await api.get(`/api/tracks`, { params: { search: q, limit: 30 } });
        setResults(data.tracks || data.items || data || []);
      } finally { setLoading(false); }
    }, 300);
    return () => clearTimeout(t);
  }, [q]);

  return (
    <div className="px-4 md:px-8 py-6 max-w-4xl mx-auto">
      <div className="relative mb-6">
        <SearchIcon className="absolute left-4 top-1/2 -translate-y-1/2 h-4 w-4 text-muted-foreground" />
        <input
          autoFocus
          value={q}
          onChange={(e) => setQ(e.target.value)}
          placeholder="Search tracks, albums…"
          className="w-full pl-11 pr-4 py-3.5 rounded-full bg-card border border-border focus:outline-none focus:ring-2 focus:ring-ring text-sm"
        />
      </div>

      {loading && <div className="text-center text-muted-foreground py-12">Searching…</div>}
      {!loading && q && results.length === 0 && (
        <div className="text-center text-muted-foreground py-12">No results for "{q}"</div>
      )}
      {!loading && results.length > 0 && (
        <div className="bg-card border border-border rounded-2xl p-2">
          {results.map((t, i) => <TrackRow key={t.id} track={t} index={i} queue={results} />)}
        </div>
      )}
      {!q && (
        <div className="text-center text-muted-foreground py-20">
          <SearchIcon className="h-10 w-10 mx-auto mb-3 opacity-40" />
          <p>Start typing to search Sura's library.</p>
        </div>
      )}
    </div>
  );
}
